import {TodosList} from "ubcommunity-shared/src/Community/Todos/TodosList";
import {PageTitles} from "ubcommunity-shared/src/constants";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";

export const ToDoPage = () => {
    usePageTitle(PageTitles.TODO);

    return <TodosList />;
};
